import { createElement } from "react"
import { AppRouteConfig } from "@/types/navigation"
import InvitePage from "@/pages/invite"

export const inviteRoutes: AppRouteConfig[] = [
  {
    path: "/invite/:token",
    element: createElement(InvitePage),
    restricted: false,
    isolated: true,
    showNav: false,
    showSideBar: false,
  },
]
